<template lang="pug">
  van-popup.van-popup--full(
    v-model="docShow"
    position="right"
    :overlay="false")

    van-nav-bar(
      :title="docData.title"
      left-arrow
      @click-left="$emit('close')")
      van-icon(
        name="video"
        slot="right"
        @click="showVideo()"
        v-if="docData.video")

    .main
      .support__data(v-html="renderDoc")

    van-popup(v-model="popupVideo" v-if="popupVideo")
      .videoWrapper
        iframe(
          width="560"
          height="315"
          :src="docData.video"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen)
</template>

<script>
import i18n from '@/locales/i18n';
import axios from 'axios';
import { getErrorId } from '@/services/error.service';

const marked = require('marked');

export default {
  data() {
    return {
      docShow: true,
      renderDoc: '',
      renderError: null,
      popupVideo: false,
    };
  },
  props: {
    base: {
      type: String,
      required: true,
    },
    docData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    // Abre un link en el navegador fuera de la aplicación
    renderDocs() {
      try {
        const path = this.docData.path;
        const instance = axios.create({ baseURL: this.base });
        const renderer = new marked.Renderer();

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        renderer.link = (href, title, text) =>
          `<a target="_blank" onclick="cordova.InAppBrowser.open('${href}', '_system', 'usewkwebview=true'); return false;" href="${href}" title="${title}">${text}</a>`; // eslint-disable-line

        renderer.table = (header, body) =>
          `<div class="table"><table><thead>${header}</thead><tbody>${body}</tbody></table></div>`;

        marked.setOptions({
          renderer,
          gfm: true,
          tables: true,
          breaks: true,
          pedantic: false,
          sanitize: false,
          smartLists: true,
          smartypants: false,
        });

        instance.get(path).then(response => {
          this.renderDoc = marked(response.data);
        });
      } catch (error) {
        // Obtengo el error
        this.renderError = getErrorId(error);
      } finally {
        this.$toast.clear();
      }
    },

    showVideo() {
      this.popupVideo = true;
    },
  },

  created() {
    this.renderDocs();
  },
};
</script>

<style scoped>
.van-popup {
  width: 100%;
}
.videoWrapper {
  position: relative;
  height: 0;
  padding-top: 25px;
  padding-bottom: 56.25%; /* 16:9 */
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
